/* Sugar Loop pages: prev/next arrows for horizontal card rows (reviews, medical board).
   Arrows only appear while the row actually overflows, so desktop grids stay untouched. */
(function () {
  var SEL = '.r5m__reviews, .ddsl-story, .lp-v5-mab__grid';
  var CSS = '.slc-nav{display:flex;justify-content:center;gap:12px;margin:14px 0 0}' +
    '.slc-nav[hidden]{display:none!important}' +
    '.slc-btn{width:40px;height:40px;border-radius:50%;border:1.5px solid #1b5732;background:#fff;color:#1b5732;' +
    'display:inline-flex;align-items:center;justify-content:center;cursor:pointer;padding:0;font-size:18px;line-height:1}' +
    '.slc-btn:disabled{opacity:.35;cursor:default}.slc-btn:focus-visible{outline:2px solid #1b5732;outline-offset:2px}';
  function init() {
    var rows = document.querySelectorAll(SEL);
    if (!rows.length) return;
    var st = document.createElement('style'); st.textContent = CSS; document.head.appendChild(st);
    rows.forEach(function (row) {
      if (row.dataset.slc) return; row.dataset.slc = '1';
      var nav = document.createElement('div'); nav.className = 'slc-nav';
      nav.innerHTML = '<button type="button" class="slc-btn" aria-label="Previous">&#8249;</button>' +
        '<button type="button" class="slc-btn" aria-label="Next">&#8250;</button>';
      row.parentNode.insertBefore(nav, row.nextSibling);
      var prev = nav.children[0], next = nav.children[1];
      function step(dir) {
        var start = row.scrollLeft, delta = dir * row.clientWidth * 0.85;
        row.scrollBy({ left: delta, behavior: 'smooth' });
        /* Some pages block smooth scrolling on the row; fall back to an instant jump. */
        setTimeout(function () { if (Math.abs(row.scrollLeft - start) < 4) row.scrollLeft = start + delta; }, 350);
      }
      function sync() {
        var over = row.scrollWidth > row.clientWidth + 10;
        nav.hidden = !over;
        prev.disabled = row.scrollLeft < 8;
        next.disabled = row.scrollLeft + row.clientWidth >= row.scrollWidth - 8;
      }
      prev.addEventListener('click', function () { step(-1); });
      next.addEventListener('click', function () { step(1); });
      row.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync);
      sync();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
